import React from 'react';
import { Footer } from '@im/ui-lib/Footer';
import { useLocalizationContext } from '@im/react-localization';
import { useFooterColumns } from './useFooterColumns';
import { useSocialMedias } from './useSocialMedias';
import { useCopyrightLinks } from './useCopyrightLinks';
import { FooterMobile } from '@im/ui-lib/Footer/FooterMobile';
import { CopyRightTO } from '@im/ui-lib/types';

type Props = {
  footerAction?: CopyRightTO;
  isAuthenticated: boolean;
  isMobile: boolean;
};

export function IngramFooter(props: Props) {
  const { locale } = useLocalizationContext();
  const { footerAction, isAuthenticated, isMobile } = props;
  const { data } = useFooterColumns(locale);
  const socialMedias = useSocialMedias(locale);
  const copyRightLinks = useCopyrightLinks();
  const buildTrackingUrl = (url: string) => {
    if (!url) return '';
    const appStore = url.includes('ios.html') ? 'ios' : 'android';
    return `${url}&UTM_Campaign=x4c_homepage_footer_${appStore}`;
  };

  const appStoreLinks = socialMedias?.appStore?.map((appStore) => ({
    ...appStore,
    url: buildTrackingUrl(appStore.url),
  }));

  const footerColumns: any = data?.footers;

  if (!copyRightLinks) return null;

  if (isMobile && !isAuthenticated) {
    return (
      <FooterMobile
        appStore={appStoreLinks}
        copyRightLinks={copyRightLinks}
        footerAction={footerAction}
        footerColumns={footerColumns}
        socialMedias={socialMedias?.socialMedia}
      />
    );
  } else {
    return (
      <Footer
        appStore={appStoreLinks}
        copyRightLinks={copyRightLinks}
        footerColumns={footerColumns}
        socialMedias={footerColumns ? socialMedias?.socialMedia : undefined}
      />
    );
  }
}
